import type { AppRouteModule } from '/@/router/types';

export const liveRoute: AppRouteModule = {
  path: '/index',
  name: 'Live',
  component: () => import('/@/views/live/index.vue'),
  meta: {
    title: '',
    auth: true,
  },
};
